// extracted by mini-css-extract-plugin
export default {"wrapper":"modal_wrapper__VWqVm","content":"modal_content__QkDI+"};